import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

console.log("Power curves controller file loaded")

export default class ChartsPowerCurvesController extends Controller {
  static values = {
    datasets: Array
  }

  connect() {
    console.log("PowerCurvesController connected.")
    console.log("datasetsValue:", this.datasetsValue)
    try {
      this.datasets = this.datasetsValue || []
      console.log("Parsed datasets:", this.datasets)
    } catch (e) {
      console.error("Erro ao parsear datasetsValue:", e)
      return
    }

    const canvas = this.element.querySelector("#powerCurvesChart")
    if (!canvas) {
      console.error("Canvas com ID #powerCurvesChart não encontrado.")
      return
    }

    this.chart = new Chart(canvas.getContext("2d"), {
      type: "scatter",
      data: {
        datasets: this.datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "top" },
          tooltip: {
            callbacks: {
              label: function (context) {
                const dsLabel = context.dataset?.label || ""
                const x = context.raw.x
                const y = context.raw.y
                return `${dsLabel}: Wind ${x} m/s, Power ${y} kW`
              }
            }
          },
          title: { display: false }
        },
        scales: {
          x: {
            type: "linear",
            position: "bottom",
            title: { display: true, text: "Wind Speed (m/s)" },
            ticks: {
              callback: (value) => `${value} m/s`
            }
          },
          y: {
            type: "linear",
            position: "left",
            title: { display: true, text: "Power (kW)" },
            ticks: {
              callback: (value) => `${value} kW`
            }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}